<script>
import { createApp } from 'vue'
import CustomAttributeValues from '../components/custom-attribute-values.vue';
import Time from '../components/time.vue';

export default {
  name: 'ModalDialogMixin',
  data() {
    return {
      modalSize: 'md',
    }
  },
  methods: {
    showModalDialogWithContent(content, size) {
      if (size == undefined) {
        size = this.modalSize
      }

      const modalSize = `app-modal-${size}`
      const modalDialog = bootstrap.Modal.getOrCreateInstance(`#${modalSize}`)

      $(`#${modalSize} .modal-content`).html(content)

      const modalDialogElement = document.getElementById(modalSize)
      if (!modalDialogElement.dataset.modalVueAppListenerInstalled) {
        modalDialogElement.dataset.modalVueAppListenerInstalled = "true"
        modalDialogElement.addEventListener('hidden.bs.modal', event => {
          if (event.target.__modalVueApp != null) {
            event.target.__modalVueApp.unmount()
            event.target.__modalVueApp = null
          }
        })
        modalDialogElement.addEventListener('show.bs.modal', event => {
          event.target.__modalVueApp = createApp()
          event.target.__modalVueApp.component('VueCustomAttributeValues', CustomAttributeValues)
          event.target.__modalVueApp.component('VueTime', Time)
          event.target.__modalVueApp.mount(`#${modalSize} .modal-content`);
        })
      }

      modalDialog.show()
    },
  }
}
</script>
